export const PLANS = {
    FREE: 'free',
    ORGANIZER: 'organizer',
} as const;

export type Plan = (typeof PLANS)[keyof typeof PLANS];

export const PLAN_VALUES = Object.values(PLANS) as Plan[];
